import { render, staticRenderFns } from "./previewAlbum.vue?vue&type=template&id=729ca5af&scoped=true&"
import script from "./previewAlbum.vue?vue&type=script&lang=js&"
export * from "./previewAlbum.vue?vue&type=script&lang=js&"
import style0 from "./previewAlbum.vue?vue&type=style&index=0&id=729ca5af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729ca5af",
  null
  
)

export default component.exports